import { APIValidationError } from '../../types/api/api';
import { Organizacion } from '../../types/organizaciones/organizacion';
import { UUID } from '../../types/standard';
import { Result, validatedApiCall } from '../api';

export interface EditOrganizacionDTO {
  id: UUID;
  nombre: string;
}

export const editOrganizacion = async (
  data: EditOrganizacionDTO,
): Promise<Result<Organizacion, APIValidationError>> => {
  return validatedApiCall<Organizacion>(`/api/organizaciones/${data.id}`, {
    method: 'PATCH',
    auth: true,
    body: JSON.stringify(data),
  });
};
